/* src/app/modules/spare-parts/spare-parts-datepicker/spare-parts-datepicker.component.scss */
:host {
  display: block;
}
sh-datepicker {
  width: 16rem;
}
/*# sourceMappingURL=spare-parts-datepicker.component.css.map */
